import CryptoJS from "crypto-js";
import queryString from "query-string";

const encryptAES = (text: string): string => {
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY || ""), {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV || ""),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString(); // Trả về chuỗi mã hóa
};

// Mã hóa query string
export const encodeQueryString = (params: Record<string, string | string[]>) => {
    const decodedParams: Record<string, string> = {};
    for (const [key, value] of Object.entries(params)) {
        const val = Array.isArray(value) ? value.join("") : value || "";
        decodedParams[key] = val;
    }

    // Mã hóa các tham số để cập nhật URL
    const encodedParams = {
        target: encodeURIComponent(encryptAES(decodedParams.target || "")),
        targetPort: encodeURIComponent(encryptAES(decodedParams.targetPort || "")),
        clientMac: encodeURIComponent(encryptAES(decodedParams.clientMac || "")),
        clientIp: encodeURIComponent(encryptAES(decodedParams.clientIp || "")),
        apMac: encodeURIComponent(encryptAES(decodedParams.apMac || "")),
        gatewayMac: encodeURIComponent(encryptAES(decodedParams.gatewayMac || "")),
        scheme: encodeURIComponent(encryptAES(decodedParams.scheme || "")),
        ssidName: encodeURIComponent(encryptAES(decodedParams.ssidName || "")),
        vid: encodeURIComponent(encryptAES(decodedParams.vid || "")),
        radioId: encodeURIComponent(encryptAES(decodedParams.radioId || "")),
        originUrl: encodeURIComponent(encryptAES(decodedParams.originUrl || "")),
        hostname: encodeURIComponent(encryptAES(decodedParams.hostname || "")),
        serverPort: encodeURIComponent(encryptAES(decodedParams.serverPort || "")),
    };

    return queryString.stringify(encodedParams, { encode: false });
};

export const decryptAES = (encryptedText: string): string => {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY || ""), {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV || ""),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8); // Trả về chuỗi đã giải mã
};

// Kiểm tra xem giá trị có phải là chuỗi đã mã hóa AES-256 không
export const isEncrypted = (value: string): boolean => {
    // Chuỗi mã hóa AES-256 thường có độ dài lớn và chứa ký tự '=' ở cuối
    return value.length > 20 && value.endsWith("=");
};

// Lấy và giải mã query string (nếu đã mã hóa)
export const getQueryString = (name: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(name);

    if (value) {
        if (isEncrypted(value)) {
            try {
                return decryptAES(decodeURIComponent(value));
            } catch (error) {
                return value; // Nếu giải mã thất bại, trả về giá trị gốc
            }
        }
        return value; // Nếu chưa mã hóa, trả về giá trị gốc
    }
    return null;
};


/**
 * 📦 Encode toàn bộ params thành 1 param duy nhất `d`
 */
export const encodeAllParams = (params: Record<string, any>): string => {
    const json = JSON.stringify(params);
    const encrypted = encryptAES(json);
    return queryString.stringify({ d: encodeURIComponent(encrypted) }, { encode: false });
};

/**
 * 📥 Decode param `d` từ URL → trả về object gốc
 */
export const decodeAllParams = (): Record<string, any> => {
    const params = queryString.parse(window.location.search);
    if (params.d) {
        try {
            const decrypted = decryptAES(decodeURIComponent(params.d as string));
            return JSON.parse(decrypted);
        } catch (err) {
            console.error("❌ Decode error:", err);
            return {};
        }
    }
    return {};
};